import { render, staticRenderFns } from "./LocaisExecucaoDataTable.vue?vue&type=template&id=2e6f0a56"
import script from "./LocaisExecucaoDataTable.vue?vue&type=script&lang=ts"
export * from "./LocaisExecucaoDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports